import { render, staticRenderFns } from "./AddNewAgentBlock.vue?vue&type=template&id=6d71c09a&scoped=true&"
import script from "./AddNewAgentBlock.vue?vue&type=script&lang=js&"
export * from "./AddNewAgentBlock.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAgentBlock.vue?vue&type=style&index=0&id=6d71c09a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d71c09a",
  null
  
)

export default component.exports